import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch"; import React, { useEffect, useState } from "react";
import SubTaskDetails from "./SubTaskDetails";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import { Button } from "@mui/material";
import { BorderColor, CheckCircle, Delete, PlayArrow, PriorityHigh } from "@mui/icons-material";
import { useHistory } from "react-router";
import FormDialog from "../../helpers/FormDialog";
import moment from "moment/moment";
import DeleteDialog from "../../helpers/DeleteDialog";
import { Cancel } from "@material-ui/icons";
import { inArray } from "../../helpers/Common_functions";
import axios from "axios";
import { errorToast, successToast, warningToast } from "../../helpers/Notification";
import { getError } from "../../store/helpers/common_functions";
import { useParams } from "react-router";
import { toast } from "react-toastify";

const TaskDndProvider = ({
    GetProject,
    task,
    onSuccess,
    PutAction,
    DeleteTask,
    isInitiator,
    deliverable,
    members,
    subTasks,
    canEdit,
    loggedUser,
    systemSettings
}) => {

    const [realTask, setRealTask] = useState();
    const [realTasks, setRealTasks] = useState([]);

    const [value, setValue] = useState({});
    const [deleteOpen, setDeleteOpen] = useState(0);

    const [open, setOpen] = useState(0);
    const [options, setOptions] = useState([]);
    const [assignees, setAssignees] = useState([]);

    const { id } = useParams();
    const loadData = async () => {
        const resp = await axios.get(`/api/task/details/${id}`);
        const assignees = resp.data?.assignees.map(v => v.resourceId);
        setAssignees(assignees ? assignees : 'empty');
        return assignees;
    };
    useEffect(() => {
        loadData();
    }, [])
    const setValue0 = (name, val) => {
        if (!name) {
            return null;
        }

        setValue(v => {
            v[name] = val;
            return { ...v };
        });
    }

    const tasks = subTasks ?? task?.SubTasks;

    useEffect(() => {
        setRealTask(task)
    }, [task]);
    useEffect(
        () => setRealTasks(tasks),
        [tasks]
    );



    const customDeleteTask = (deleteId) => {
        if (realTask) {
            tasks.forEach((v) => {
                if (v.id === deleteId) {
                    v.loading = true;
                }
            });
            setRealTask({ ...realTask });
        }
        return DeleteTask(deleteId);
    }

    const onTaskChange = async (info) => {
        if (realTask) {
            let inApproved = false;
            tasks.forEach((v) => {
                if (v.id === info.id) {
                    v.status = info.status ?? v.status;
                    v.name = info.name ?? v.name;
                    v.description = info.description ?? v.description;
                    v.loading = true;
                }
            });

            if (inApproved) {
                return;
            }

            setRealTask({ ...realTask });

            const resp = await PutAction(`/api/task/subtask/change/status/${info.id}`, info);
            if (!resp.status) {
                errorToast(getError(resp));
            }
            await onSuccess();
            tasks.forEach((v) => {
                if (v.id === info.id) {
                    v.loading = false;
                }
            });
            setRealTask({ ...realTask });
        }
    }


    const history = useHistory();

    const allTheMeetings = async () => {
        const data = await axios.get('api/meeting/?status=completed');
        setOptions(data.data.meeting);
    }
    useEffect(() => {
        allTheMeetings()
    },
        []
    );

    const handleStartTask = () => {
        if (assignees.length === 0) {
            warningToast("Task can't be started, it have to be assigned to someone First")
        } else {
            setDeleteOpen(4);
        }
    };

    const taskInitiator = task.initiator;
    const loggedInUser = loggedUser.Resource.id;

    const handleDeleteTask = () => {
        if (taskInitiator !== loggedInUser) {
            errorToast("Can't Delete the Task you didn't Initiate")
        } else {
            setDeleteOpen(1)
        }
    }
    const mainBackground = systemSettings?.mainBackground;


    return (
        <div>

            <FormDialog maxWidth={'sm'} open={open > 0} onSuccess={onSuccess} setOpen={setOpen}
                url={`/api/task/update/${task.id}`}
                title={"Update Task"} fields={[
                    {
                        name: "name",
                        label: "Task name",
                        value: value['name'],
                        required: true,
                        setValue: (val) => setValue0('name', val),
                    },
                    {
                        name: "startDate",
                        label: "Start Date",
                        value: value['startDate'],
                        type: 'date',
                        required: true,
                        setValue: (val) => setValue0('startDate', val),
                    },
                    {
                        name: "endDate",
                        label: "End Date",
                        value: value['endDate'],
                        required: true,
                        type: 'date',
                        setValue: (val) => setValue0('endDate', val),
                    },
                    {
                        name: "meetingId",
                        label: "Orginated From",
                        value: value['meetingId'],
                        required: false,
                        type: 'select',
                        values: options && options.map((v) => {
                            return { value: v.id, label: v.name }
                        }),
                        col: 12,
                        setValue: (val) => setValue0('meetingId', val),

                    },
                    {
                        name: "description",
                        label: "Task Description",
                        value: value['description'],
                        // type: 'editor',
                        type: 'textarea',
                        setValue: (val) => setValue0('description', val),
                    },
                ]} />
            <DeleteDialog
                open={deleteOpen > 0}
                setOpen={() => {
                    setDeleteOpen(0);
                }}
                onSuccess={inArray([2, 3], deleteOpen) ? onSuccess : history.goBack}
                body={{
                    id: task.id,
                    status: deleteOpen === 3 ? "canceled"
                        : deleteOpen === 2 ? "completed"
                            : deleteOpen === 4 ? "in-progress"
                                : undefined
                }}
                info={deleteOpen === 2 || deleteOpen === 4}
                usePut={deleteOpen === 3 || deleteOpen === 4}
                bodyText={
                    deleteOpen === 3 ? 'Are you sure to cancel this task?'
                        : (deleteOpen === 4 ? 'Are you sure to start this task?' : undefined)
                }
                buttonTitle={
                    deleteOpen === 3 ? 'Cancel'
                        : (deleteOpen === 2 ? 'Complete'
                            : (deleteOpen === 4 ? 'Start' : 'Delete'))
                }
                title={
                    deleteOpen === 3 ? 'Cancel Task'
                        : (deleteOpen === 2 ? 'Complete Task!'
                            : (deleteOpen === 4 ? 'Start Task' : 'Delete Task'))
                }
                url={
                    deleteOpen === 1 ? `/api/task/delete/${task.id}`
                        : (deleteOpen === 4 ? `/api/task/change/status/${task.id}`
                            : `/api/task/change/status/${task.id}`)
                }
            />

            <DndProvider
                backend={HTML5Backend}
                context={window}
            >
                <div className="flex flex-wrap justify-center mt-3 ml-4 mr-4">
                    <div className={"w-full sm:w-6/12 md:w-3/12 lg:w-2/12 xl:w-[20%] px-5"}>
                        <SubTaskDetails
                            title={"TO DO "}
                            UpdateTask={PutAction}
                            onTaskChange={onTaskChange}
                            action={canEdit}
                            onSuccess={onSuccess}
                            members={members}
                            DeleteTask={customDeleteTask}
                            isInitiator={isInitiator}
                            GetProject={GetProject}
                            deliverable={deliverable}
                            status={"to-do"}
                            task={realTask}
                            tasks={realTasks}
                            canEdit={canEdit}

                        />
                    </div>

                    <div className={"w-full sm:w-6/12 md:w-3/12 lg:w-2/12 xl:w-[20%] px-5"}>
                        <SubTaskDetails
                            title={"IN PROGRESS"}
                            UpdateTask={PutAction}
                            DeleteTask={customDeleteTask}
                            isInitiator={canEdit}
                            onSuccess={onSuccess}
                            onTaskChange={onTaskChange}
                            GetProject={GetProject}
                            members={members}
                            status={"in-progress"}
                            deliverable={deliverable}
                            task={realTask}
                            tasks={realTasks}
                            canEdit={canEdit}
                        />
                    </div>

                    <div className={"w-full sm:w-6/12 md:w-3/12 lg:w-2/12 xl:w-[20%] px-5"}>
                        <SubTaskDetails
                            title={"UNDER REVIEW"}
                            UpdateTask={PutAction}
                            DeleteTask={customDeleteTask}
                            isInitiator={canEdit}
                            onSuccess={onSuccess}
                            onTaskChange={onTaskChange}
                            GetProject={GetProject}
                            members={members}
                            status={"to-verify"}
                            deliverable={deliverable}
                            task={realTask}
                            tasks={realTasks}
                            canEdit={canEdit}
                        />
                    </div>

                    <div className={"w-full sm:w-6/12 md:w-3/12 lg:w-2/12 xl:w-[20%] px-5"}>
                        <SubTaskDetails
                            status={"completed"}
                            onTaskChange={onTaskChange}
                            GetProject={GetProject}
                            onSuccess={onSuccess}
                            deliverable={deliverable}
                            members={members}
                            title={"COMPLETED"}
                            DeleteTask={customDeleteTask}
                            isInitiator={canEdit}
                            task={realTask}
                            tasks={realTasks}
                            UpdateTask={PutAction}
                            canEdit={canEdit}
                        />
                    </div>

                    <div className={"w-full sm:w-6/12 md:w-3/12 lg:w-2/12 xl:w-[19%] px-5"}>
                        <SubTaskDetails
                            status={"overdue"}
                            action={false}
                            onTaskChange={onTaskChange}
                            GetProject={GetProject}
                            onSuccess={onSuccess}
                            deliverable={deliverable}
                            title={"OVERDUE"}
                            DeleteTask={customDeleteTask}
                            isInitiator={isInitiator}
                            task={realTask}
                            tasks={realTasks}
                            UpdateTask={PutAction}
                        />
                    </div>
                </div>
            </DndProvider>
            <div className={'flex justify-end p-3 mt-10 mb-10 mr-4'}>
                <div className={'mr-2'}>
                    <Button onClick={() => history.goBack()} color={'error'}>Go Back</Button>
                </div>

                {canEdit && !inArray(['completed', 'canceled'], task.status) ? (
                    <div className={'mr-2'}>
                        <Button
                            style={{ backgroundColor: mainBackground }} variant={'contained'}
                            startIcon={<PriorityHigh />}
                            onClick={async () => {
                                const response = await PutAction(`/api/task/change-urgency/${task.id}`, { isUrgent: !task.isUrgent });

                                if (!response.status) {
                                    errorToast(getError(response));
                                    return;
                                }
                                successToast(response?.data.message || (task.isUrgent ? "Task marked as un-urgent successfully By Admin" : "Task marked as urgent successfully By Admin"));
                                onSuccess();
                            }}
                        >
                            {task.isUrgent ? 'Mark as Un-urgent' : 'Mark as Urgent'}
                        </Button>
                    </div>
                ) : null}

                {canEdit && !inArray(['completed', 'canceled'], task.status) ? <>
                    <div className={'mr-2'}>
                        <Button
                            style={{ backgroundColor: mainBackground }} variant={'contained'}
                            onClick={() => {
                                setOpen(2);
                                setValue0('name', task.name);
                                setValue0('startDate', moment(task.startDate).utc().format("YYYY-MM-DDTHH:mm"));
                                setValue0('endDate', moment(task.endDate).utc().format("YYYY-MM-DDTHH:mm"));
                                setValue0('description', task.description);
                            }} startIcon={<BorderColor />}>Edit Task</Button>
                    </div>
                    <div className={'mr-2'}>
                        {task.status === 'to-do' && (
                            <span className={'mr-2'}>
                                <Button onClick={handleStartTask} style={{ backgroundColor: mainBackground }} variant={'contained'} startIcon={<PlayArrow />}>Start Task</Button>
                            </span>
                        )}
                        {task.status !== 'to-do' && (
                            <span className={'mr-2'}>
                                {task.initiator === loggedUser.Resource.id ?
                                    <Button onClick={() => setDeleteOpen(2)} style={{ backgroundColor: mainBackground }} variant={'contained'} startIcon={<CheckCircle />}>Complete Task</Button> : null}
                            </span>
                        )}
                        <Button onClick={() => setDeleteOpen(3)} style={{ backgroundColor: mainBackground }} variant={'contained'} startIcon={<Cancel />}>Cancel Task</Button>
                    </div>
                    {task.initiator === loggedUser.Resource.id ? <Button onClick={handleDeleteTask} color={'error'} variant={'contained'} startIcon={<Delete />}>Delete Task</Button> : null}
                </> : null}

            </div>
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskDndProvider);